// extracted by mini-css-extract-plugin
export var container = "_gy-1";
export var cornerButtonContainer = "_gy-6";
export var disabled = "_gy-2";
export var dragActive = "_gy-3";
export var fileContainer = "_gy-5";
export var hiddenInput = "_gy-4";
export var widthContainer = "_gy-0";